import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ location }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            google {
              siteVerification {
                name
                content
              }
            }
            facebook {
              id
            }
            description
            author
            image
            siteUrl
            social {
              name
              url
            }
          }
        }
      }
    `
  )
  const {
    title,
    google,
    facebook,
    description,
    author,
    image,
    siteUrl,
  } = site.siteMetadata
  const keywords = `Christchurch, New Zealand, Web Developer, Javascript Developer`
  const openGraph = [
    {
      property: `og:image`,
      content: `${siteUrl}/${image}`,
    },
    {
      property: `og:title`,
      content: title,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: `website`,
    },
  ]
  // https://developers.facebook.com/docs/sharing/webmasters/#markup
  const facebookMarkup = [
    {
      property: `fb:app_id`,
      content: facebook.id,
    },
  ]
  // https://developer.twitter.com/en/docs/tweets/optimize-with-cards/guides/getting-started
  const twitterCardMarkup = [
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:creator`,
      content: author,
    },
    // {
    //   name: `twitter:site`,
    //   content: author,
    // },
  ]
  const meta = [
    {
      name: `description`,
      content: description,
    },
    {
      name: `keywords`,
      content: keywords,
    },
  ]
  meta.push(...openGraph)
  meta.push(...facebookMarkup)
  meta.push(...twitterCardMarkup)

  if (location?.pathname === "/") {
    meta.push({
      name: google.siteVerification.name,
      content: google.siteVerification.content,
    })
  }
  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      title={title}
      titleTemplate={`%s | ${title}`}
      meta={meta}
    />
  )
}

export default SEO
